import React, { useEffect, useState } from "react";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import AddIcon from "../../../../../assets/disabilityIcons/Frame 427319007.svg";
import * as Style from "../../../../../newComponents/styledComponents/PersonalInstruction";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import { Table } from "antd";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import useModuleData from "../../hooks/useFetchItems";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useModalHandlers from "../../hooks/useModalHandler";
import { financialDocumentationCols } from "./AllColumnsData";
import useChangeHandler from "../../hooks/useChangeHandler";
import deathApi from "../../../../../apis/death.api";
import AddModal from "../../../../../newComponents/styledComponents/Modal/AddModal";
import { Modal } from "antd";
import swal from "sweetalert";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export default function FinancialDocumentation(props) {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Financial Documentation");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const [listofPassword, setListofPassword] = useState([]);
  const [message, setMessage] = useState("");
  const [userData, setUserData] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addData, setaddData] = useState({});

  const history = useHistory();
  const { fetchData, formatModuleKey, setTableData, setToUpdate, tableData } =
    useModuleData(
      ["Safe Deposit Box Information", "Asset", "Liabilities and Credit", "Income"],
      setLoading
    );
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { attributes } = useGetAttributes(
    ["Safe Deposit Box Information"],
    setLoading
  );
  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };
  const AddIncome = () => {
    history.push("/income_new");
  };

  const fnEdit = (record) => {
    history.push(`/assets_new/attributes/${record.module}/${record.id}`);
  };
  console.log("attributesssss", attributes);

  const liabilitiesTable = [
    { title: "Loans", key: 1 },
    { title: "Safe Deposit Box Information", key: 2 },
  ];

  const IncomeTable = [
    { title: "Income", key: 3 },
    { title: "Tax Record", key: 4 },
  ];
  const showModalOtp = async () => {
    setIsOtpModalVisible(true);
    try {
      const ID = localStorage.getItem("accessId");

      let data = await deathApi.configOtp(ID);
      console.log("data>>", data);
      swal(data.message);
      // console.log("data.message",data.message)
    } catch (error) {
      console.log("e ", error);
    }
  };

  const AllColumns = financialDocumentationCols(
    viewModal,
    updateModal,
    deleteRecord
  );
  const tableDataObj = {
    Assets: tableData.assetData,
    Loans: tableData.liabilitiesAndCreditData,
    "Safe Deposit Box Information": tableData.safeDepositBoxInformationData,
    Income: tableData.incomeData,
  };
  const handleCancel = () => {
    setIsOtpModalVisible(false);
    localStorage.setItem("otp", "");
  };
  const handleOk = async () => {
    let message = {};
    let data = {};
    if (userData !== undefined) {
      setLoading(true);

      try {
        const ID = localStorage.getItem("accessId");
        data = await deathApi.fetchPasswords(userData && userData.otp, ID);
        message = data;
        setMessage(data);
        // this.setState({ message: data })
        console.log("data passwordlist", data);
        if (data && data.status === 200) {
          console.log("formData.otp", userData);
          localStorage.setItem("otp", userData.otp);

          if (data && data.data) {
            setListofPassword(data.data);
          }
        }
        setLoading(false);
        if (userData.otp) {
          setIsOtpModalVisible(false);
        } else {
          swal("Oops!", "Invalid OTP", "error");
        }
      } catch (error) {
        console.log("here in catch", error);
      }
    }
    if (data.status === 400 && data.message === "Please enter a valid OTP") {
      swal("Oops!", "Please enter a valid OTP", "error");
      setIsOtpModalVisible(true);
    }
  };
  const handleInputChange = (name, value) => {
    setUserData({
      ...userData,
      [name]: value,
    });
  };
  const handleKeyPress = (event) => {
    console.log("submit");
    if (event.key === "Enter") {
      handleOk();
    }
  };
  const cols = [
    {
      title: "Site/App/Program",
      dataIndex: "appName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "UserName",
      dataIndex: "userName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Who's Password",
      dataIndex: "passwordFor",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Password Hint",
      dataIndex: "passwordHint",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Website URL",
      dataIndex: "appUrl",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "2FA",
      dataIndex: "twoFactor",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Pin",
      dataIndex: "pin",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Security Question",
      dataIndex: "securityQuestion",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Answer",
      dataIndex: "answer",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Notes",
      dataIndex: "note",
      render: (record) => (record ? record : "N/A"),
    },
  ];
  const getPasswordList = async () => {
    console.log("localStorage.getItem", localStorage.getItem("otp"));
    if (!localStorage.getItem("otp")) {
      localStorage.setItem("otp", "");
    }
    if (localStorage.getItem("otp") === "") {
      showModalOtp();
    } else {
      // this.props.handleLoader();
      setLoading(true);
      console.log("this.state.userData", formData);
      if (localStorage.getItem("otp")) {
        const ID = localStorage.getItem("accessId");

        let data = await deathApi.fetchPasswords(
          localStorage.getItem("otp"),
          ID
        );
        if (data.message === "This is an expired OTP") {
          showModalOtp();
        } else {
          if (data && data.data) {
            setListofPassword(data.data);
          }
        }
        setLoading(false);
        // this.props.handleLoader();
      }
    }
  };
  const isSecondPasswordGranted = async () => {
    try {
      // this.props.handleLoader();
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await deathApi.getSecondPasswordStatus(ID);
      // this.props.handleLoader();
      setLoading(false);

      console.log("data.message", data.date.secondPasswordGranted);
      // this.setState({
      //   OTP_Status: data.date.secondPasswordGranted,
      // });
      if (data.date.secondPasswordGranted === 1) {
        if (!localStorage.getItem("otp")) {
          localStorage.setItem("otp", "");
        }
        if (localStorage.getItem("otp") === "") {
          showModalOtp();
        } else {
          // this.props.handleLoader();
          setLoading(true);
          console.log("this.state.userData", formData);
          if (localStorage.getItem("otp")) {
            const ID = localStorage.getItem("accessId");

            let data = await deathApi.fetchPasswords(
              localStorage.getItem("otp"),
              ID
            );
            if (data.message === "This is an expired OTP") {
              showModalOtp();
            } else {
              if (data && data.data) {
                setListofPassword(data.data);
              }
            }
            setLoading(false);
            // this.props.handleLoader();
          }
        }
      }

      if (data.date.secondPasswordGranted === 0) {
        setLoading(true);
        // this.props.handleLoader();
        swal(
          "Restricted!",
          "You have not been granted access to this information.",
          "warning"
        );
        setLoading(false);

        // this.props.handleLoader();
      }
    } catch (error) {
      console.log("e ", error);
    }
  };
  useEffect(() => {
    getPasswordList();
  }, []);
  const handelOpenPasswordModal = () => {
    setShowAddModal(true);
  };
  const handelClosePasswordModal = () => {
    setShowAddModal(false);
  };
  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const submitData = () => {
    console.log("submit data", addData);
    createPasswords();
    handelClosePasswordModal();
  };
  const createPasswords = async () => {
    // checxk if already formData contains some data then initialize it with empty

    var arr = [addData];
    try {
      let data = arr;
      if (Array.isArray(data) && data.length > 0) {
        setLoading(true);
        let api_res = await deathApi.addPasswords({
          listOfPasswordsForm: data.map((item) => {
            return {
              appName: item["Site / App / Program or Printed Sheet"],
              userName: item["User Name"],
              passwordFor: item["Who's Password"],
              passwordHint: item["Password Hint"],
              appUrl: item["Website URL"],
              twoFactor: item["2FA"],
              pin: +item.Pin,
              note: item.Notes,
              securityQuestion: item["Security Question"],
              answer: item.Answer,
            };
          }),
        });
        setLoading(false);
        getPasswordList();

        return api_res;
      }
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };
  const fields = [
    {
      title: "Site / App / Program or Printed Sheet",
      type: "input",
      index: "SiteAppProgram",
    },
    {
      title: "User Name",
      type: "input",
      index: "UserName",
    },
    {
      title: "Who's Password",
      type: "input",
      index: "WhosPassword",
    },
    {
      title: "Password Hint",
      type: "input",
      index: "PasswordHint",
    },
    {
      title: "Website URL",
      type: "input",
      index: "WebsiteURL",
    },
    {
      title: "2FA",
      type: "input",
      index: "TwoFA",
    },
    {
      title: "Pin",
      type: "input",
      index: "Pin",
    },
    {
      title: "Security Question",
      type: "input",
      index: "SecurityQuestion",
    },
    {
      title: "Answer",
      type: "input",
      index: "Answer",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
  ];

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Financial Documentation</h2>
        <ToolTipCreator name={"Disaster_Financial_Documentation"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>
      <div className="parent-title-container">
        <h2 className="parent-title">Assets</h2>
        <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div>
      </div>
      {
        <CollapseableTable key={1} title={"Assets"} show={true}>
          <Table
            columns={AllColumns["Asset"]}
            dataSource={tableDataObj["Assets"]}
          />
          .
        </CollapseableTable>
      }

      {/* <CollapseableTable /> */}
      <div className="parent-title-container">
        <h2 className="parent-title">Liabilities</h2>
        <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div>
      </div>
      {liabilitiesTable.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          show={table.title === "Loans" && true}
          onClick={() =>
            table.title === "Safe Deposit Box Information" &&
            showModal(table.title)
          }
        >
          <Table
            columns={AllColumns[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}
      <div className="parent-title-container">
        <h2 className="parent-title">Income</h2>
        <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div>
      </div>
      {IncomeTable.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          show={table.title === "Total Income" ? true : false}
          onClick={() =>
            table.title === "Tax Record" ? AddDocument() : AddIncome()
          }
        >
          <Table
            columns={AllColumns[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>

      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Passwords</h2>
        <ToolTipCreator name={"Disaster_Passwords"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>
      {
        <CollapseableTable title={"All Passwords"} show={true}>
          <div
            className="add-condition-button-container"
            onClick={handelOpenPasswordModal}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent:"flex-end"
            }}
          >
            <img src={AddIcon} alt="add icon" />
          </div>
          <Table columns={cols} dataSource={listofPassword} />
        </CollapseableTable>
      }
      {showAddModal &&
      <AddModal
        show={showAddModal}
        close={handelClosePasswordModal}
        fields={fields}
        modalTitle="Add New Password"
        handlechange={handlechange}
        submitData={submitData}
        handleDocumentChange={handleDocumentChange}
        handleDatePickerChange={handleDatePickerChange}
        handleRadioChange={handleRadioChange}
      />}
      <NewLoader isLoading={loading} />
      <Modal
        visible={isOtpModalVisible}
        footer={null}
        closable={false}
        centered
      >
        <div style={{ marginTop: "20px" }}>
          {/* <div style={{padding:"50px",background:"black",overflow:"hidden"}}>hellow</div> */}
          <h3 style={{ color: "#4d5e80", marginBottom: "10px" }}>
            {" "}
            List of Passwords
          </h3>
          <div className="">
            <h2 className="otp-heading" style={{ color: "#4d5e80" }}>
              This passcode provides another layer of security for your list of
              passwords. The passcode is only valid for this session.
            </h2>
            <div>
              <Style.Input
                onKeyPress={handleKeyPress}
                onChange={(e) => {
                  e.preventDefault();
                  handleInputChange(e.target.name, e.target.value);
                }}
                id="otp"
                type="text"
                // pattern="[0-9]{10}"
                pattern="[0-9.]+"
                // pattern="[0-9]+"
                // pattern="\d*"
                // maxlength="4"
                maxLength={6}
                placeholder="***OTP***"
                name="otp"
              />

              <Style.ResendButton
                onClick={async () => {
                  console.log();
                  const ID = localStorage.getItem("accessId");
                  setLoading(true);
                  let data = await deathApi.configOtp(ID);
                  console.log("data>>", data);
                  swal(data.message);
                  setLoading(false);
                }}
              >
                Resend OTP
              </Style.ResendButton>

              <Style.WrapperButtons>
                <Style.CancelButton
                  onClick={() => {
                    handleCancel();
                  }}
                >
                  Cancel
                </Style.CancelButton>
                <Style.SaveButton onClick={handleOk}>Done</Style.SaveButton>
              </Style.WrapperButtons>
            </div>
          </div>
        </div>
        {/* <Loader isLoading={loading} /> */}
      </Modal>
    </div>
  );
}
